<div class="header">
    <h2>{{ 'organisations.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="organisations-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'organisations.error.unavailable' | translate" />
} @else if (organisation(); as organisation) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'organisations.fieldset.basic' | translate }}</h2>
            <div class="logo-field">
                <span class="label">{{ 'organisations.form.logo' | translate }}</span>
                @if (form.controls.logoMediaId.value; as logoMediaId) {
                    <div class="logo-preview">
                        <app-media-image [mediaId]="logoMediaId" [alt]="'organisations.form.logo' | translate" />
                    </div>
                }
                <div class="logo-actions">
                    <p-button
                        [label]="(form.controls.logoMediaId.value ? 'organisations.form.changeLogo' : 'organisations.form.selectLogo') | translate"
                        icon="pi pi-image"
                        [outlined]="true"
                        severity="secondary"
                        data-test="organisations-edit-select-logo"
                        (onClick)="onSelectLogo()"
                    />
                    @if (form.controls.logoMediaId.value) {
                        <p-button
                            [label]="'organisations.form.removeLogo' | translate"
                            icon="pi pi-times"
                            [text]="true"
                            severity="secondary"
                            data-test="organisations-edit-clear-logo"
                            (onClick)="onClearLogo()"
                        />
                    }
                </div>
            </div>
            <app-form-input [control]="form.controls.name" [label]="'organisations.form.name' | translate" inputId="name" testId="organisations-edit-name" />
        </div>

        <div class="section">
            <h2>{{ 'organisations.fieldset.contact' | translate }}</h2>
            <app-form-input
                [control]="form.controls.contactName"
                [label]="'organisations.form.contactName' | translate"
                inputId="contactName"
                testId="organisations-edit-contact-name"
            />
            <app-form-input
                [control]="form.controls.contactEmail"
                [label]="'organisations.form.contactEmail' | translate"
                inputId="contactEmail"
                testId="organisations-edit-contact-email"
            />
        </div>

        <div class="section">
            <h2>{{ 'organisations.fieldset.schools' | translate }}</h2>
            <app-form-multiselect
                [control]="form.controls.schoolIds"
                [label]="'organisations.form.schools' | translate"
                [placeholder]="'organisations.form.schools.placeholder' | translate"
                [options]="schoolOptions()"
                [filter]="true"
                inputId="schoolIds"
                testId="organisations-edit-school-ids"
            />
        </div>
    </form>

    <div class="footer">
        <p-button
            [label]="'organisations.form.cancel' | translate"
            [outlined]="true"
            severity="secondary"
            data-test="organisations-edit-cancel"
            (onClick)="close()"
        />
        <p-button
            type="submit"
            [label]="'organisations.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="organisations-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
